import { RawProjectLineItem, UIFCartLineItem } from "./line-item";

export class RawProject {

    public constructor(...lineItems: UIFCartLineItem[]) {
        this.items = lineItems.map(l => this.mapLineItemFromUif(l));
    }

    public items: RawProjectLineItem[];

    public mapLineItemFromUif(inputUifLineItem: UIFCartLineItem): RawProjectLineItem { 
        const uifLineItem = structuredClone(inputUifLineItem);

        //TODO: Ask Ivan whether _hidden is still needed for originalProductId
        uifLineItem.properties = {
            ...uifLineItem.properties,
            _hidden: {
                images: uifLineItem.properties?._hidden?.images,
                originalProductId: uifLineItem.originalProductId,
                originalProductUrl: uifLineItem.originalProductUrl,
                sku: uifLineItem.sku
            } 
        };

        const rawProjectLineItem: RawProjectLineItem = {
            key: uifLineItem.key,
            userId: uifLineItem.properties?._userId,
            quantity: uifLineItem.quantity,
            designIds: structuredClone(uifLineItem.properties?._stateId),
            fields: structuredClone(uifLineItem.properties?._fields),
            hidden: JSON.stringify(uifLineItem.properties?._hidden),
            pimProductVariantInfo: {
                productId: (uifLineItem.properties as unknown as any)?.pimProductVariantInfo?.productId,
                productVersionId: (uifLineItem.properties as unknown as any)?.pimProductVariantInfo?.productVersionId,
                productVariantId: (uifLineItem.properties as unknown as any)?.pimProductVariantInfo?.productVariantId,
            },
            resources: structuredClone(uifLineItem.properties?._resources)
        };

        return rawProjectLineItem;
    }
}